//
//
//
//
//
//
//
//
//
//
//
//
//
import activateOpenFacets from '~/const/openFacet';

var CategoryDescription = function CategoryDescription() {
  return import(
  /* webpackChunkName: "category" */
  '~/components/molecules/Category/CategoryDescription.vue');
};

var CategoryLinkMapping = function CategoryLinkMapping() {
  return import(
  /* webpackChunkName: "category" */
  '~/components/molecules/Category/CategoryLinkMapping.vue');
};

export default {
  name: 'CategoryInformationalContent',
  components: {
    CategoryDescription: CategoryDescription,
    CategoryLinkMapping: CategoryLinkMapping
  },
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  computed: {
    withQuickAccessLinks: function withQuickAccessLinks() {
      return this.info.quick_access_links && this.info.quick_access_links.length && !activateOpenFacets(this.$cookies);
    }
  }
};